export default {
    methods: {
        /**
         * Define contact as new corporation owner
         * 
         * @param {object} contact 
         * @public
         */
        defineAsCorporationOwner(contact) {
            // Find old owner contact
            const oldOwner = this.contacts.find(c => (c.sellsyadmin !== null && c.sellsyadmin.staff_ownerid == 0));

            this.$confirm(this.$l10n.__(`Définir %(staffName)s comme nouveau propriétaire du compte, à la place de %(oldOwnerStaffName)s ?`, {
                'staffName': contact.fullName,
                'oldOwnerStaffName': oldOwner.fullName
            }), this.$l10n.__('Changement de propriétaire'), {
                cancelButtonText: this.$l10n.__('Annuler'),
                confirmButtonText: this.$l10n.__('Confirmer le changement'),
                confirmButtonClass: 'btn btn-primary',
                type: 'warning'
            }).then(() => {
                this.$ajax.patch(`/rest/corporation/${contact.sellsyadmin.staff_corpid}/owner`, {
                    staffid: contact.sellsyadmin.staff_id
                }, {}, () => {
                    // Update value of property "ownerid"
                    oldOwner.sellsyadmin.staff_ownerid = contact.sellsyadmin.staff_id
                    contact.sellsyadmin.staff_ownerid = 0;
                    // Update actions
                    oldOwner.actions = this.setActions(oldOwner)
                    contact.actions = this.setActions(contact)
                    // notify
                    Push.success(this.$l10n.__("%(staffName)s est désormais le nouveau propriétaire du compte", { 'staffName': '<b>' + contact.fullName + '</b>' }), false)
                }, 
                (error) => Push.error(this.$l10n.__("Une erreur s'est produite lors du changement de propriétaire du compte"), false)
                );
            }).catch(() => {});
        },
    }
}
